import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useMasterDataBatch } from '../../utils/useMasterData';
import axios from 'axios';
import { appendApplicationId, getApiBaseUrl } from '../../utils/apiConfig';
import { getStorageValues } from '../../shared/CommonFunctions';
import FileUploadModal from '../../shared/file-upload/FileUploadModal';
import VehicleMediaGrid from './VehicleMediaGrid';

function EditVehicle({ VehicleData, sendDataToParent }) {
  const [formData, setFormData] = useState(VehicleData || {});
  const [launchDate, setLaunchDate] = useState(null);
  const [discontinueDate, setDiscontinueDate] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [mediaRefreshKey, setMediaRefreshKey] = useState(0);

  const vehicleId = formData?.VehicleId ?? VehicleData?.VehicleId ?? null;

  // Fetch master data for dropdowns
  const { dataMap: masterData } = useMasterDataBatch([
    'vehicleType',
    'fuelType',
    'engineCC',
    'segment',
    'variant',
    'model',
    'color'
  ]);

  const vehicleTypeOptions = masterData?.vehicleType || [];
  const fuelTypeOptions = masterData?.fuelType || [];
  const engineCCOptions = masterData?.engineCC || [];
  const segmentOptions = masterData?.segment || [];
  const variantOptions = masterData?.variant || [];
  const modelOptions = masterData?.model || [];
  const colorOptions = masterData?.color || [];

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    const updatedData = {
      ...formData,
      [name]: value
    };
    setFormData(updatedData);
    sendDataToParent(updatedData);
  }

  function handleSelectChange(name, selectedOption) {
    const updatedData = {
      ...formData,
      [name]: selectedOption ? selectedOption.label : ''
    };
    setFormData(updatedData);
    sendDataToParent(updatedData);
  }

  function handleDateChange(name, date) {
    if (name === 'LaunchDate') {
      setLaunchDate(date);
    } else if (name === 'DiscontinueDate') {
      setDiscontinueDate(date);
    }
    const updatedData = {
      ...formData,
      [name]: date || null
    };
    setFormData(updatedData);
    sendDataToParent(updatedData);
  }

  useEffect(() => {
    setFormData(VehicleData || {});
    setLaunchDate(VehicleData?.LaunchDate ? new Date(VehicleData.LaunchDate) : null);
    setDiscontinueDate(VehicleData?.DiscontinueDate ? new Date(VehicleData.DiscontinueDate) : null);
  }, [VehicleData]);

  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Discontinued', label: 'Discontinued' }
  ];

  // Helper function to find selected option
  const findSelectedOption = (options, value) => {
    return options.find(opt => opt.label === value) || null;
  };

  return (
    <>
      <div className="card-body px-0">
        <nav className="nav nav-style-6 nav-pills mb-3 nav-justified d-sm-flex d-block" role="tablist">
          <a className="nav-link active" data-bs-toggle="tab" role="tab" href="#vehicle-details-edit" aria-selected="true">
            Vehicle details
          </a>
          <a className="nav-link" data-bs-toggle="tab" role="tab" href="#vehicle-media-edit" aria-selected="false" tabIndex="-1">
            Photos/Videos
          </a>
        </nav>

        <div className="tab-content">
          <div className="tab-pane text-muted active show" id="vehicle-details-edit" role="tabpanel">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Vehicle Type<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="hidden"
                    name="VehicleId"
                    value={formData.VehicleId ?? ""}
                  />
                  <Select
                    name="VehicleType"
                    options={vehicleTypeOptions}
                    onChange={(option) => handleSelectChange('VehicleType', option)}
                    value={findSelectedOption(vehicleTypeOptions, formData.VehicleType)}
                    isClearable
                    placeholder="Select Vehicle Type"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Manufacturer<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="Manufacturer"
                    value={formData.Manufacturer ?? ""}
                    onChange={handleChange}
                    placeholder="Enter manufacturer name"
                  />
                </div>
              </div>


  
  


              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Model<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="Model"
                    options={modelOptions}
                    onChange={(option) => handleSelectChange('ModelName', option)}
                    value={findSelectedOption(modelOptions, formData.ModelName)}
                    isClearable
                    placeholder="Select Model"
                  />
                </div>
              </div>




              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Variant<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="Variant"
                    options={variantOptions}
                    onChange={(option) => handleSelectChange('Variant', option)}
                    value={findSelectedOption(variantOptions, formData.Variant)}
                    isClearable
                    placeholder="Select Variant"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Segment<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="Segment"
                    options={segmentOptions}
                    onChange={(option) => handleSelectChange('Segment', option)}
                    value={findSelectedOption(segmentOptions, formData.Segment)}
                    isClearable
                    placeholder="Select Segment"
                  />
                </div>
              </div>


    
    

              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Color<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="Color"
                    options={colorOptions}
                    onChange={(option) => handleSelectChange('Color', option)}
                    value={findSelectedOption(colorOptions, formData.Color)}
                    isClearable
                    placeholder="Select Color"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Fuel Type<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="FuelType"
                    options={fuelTypeOptions}
                    onChange={(option) => handleSelectChange('FuelType', option)}
                    value={findSelectedOption(fuelTypeOptions, formData.FuelType)}
                    isClearable
                    placeholder="Select Fuel Type"
                  />
                </div>
              </div>



              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    Engine CC<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="EngineCC"
                    options={engineCCOptions}
                    onChange={(option) => handleSelectChange('EngineCC', option)}
                    value={findSelectedOption(engineCCOptions, formData.EngineCC)}
                    isClearable
                    placeholder="Select Engine CC"
                  />
                </div>
              </div>
      



              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Launch Date</label>
                  <DatePicker
                    className="form-control"
                    selected={launchDate}
                    onChange={(date) => handleDateChange('LaunchDate', date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select launch date"
                    isClearable
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Discontinue Date</label>
                  <DatePicker
                    className="form-control"
                    selected={discontinueDate}
                    onChange={(date) => handleDateChange('DiscontinueDate', date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select discontinue date"
                    isClearable
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Status<span style={{ color: "red" }}>*</span></label>
                  <Select
                    name="Status"
                    options={statusOptions}
                    onChange={(option) => handleSelectChange('Status', option)}
                    value={findSelectedOption(statusOptions, formData.Status)}
                    isClearable
                    placeholder="Select Status"
                  />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Remarks</label>
                  <textarea
                    className="form-control"
                    name="Remarks"
                    rows="2"
                    value={formData.Remarks ?? ""}
                    onChange={handleChange}
                    placeholder="Enter remarks"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane text-muted" id="vehicle-media-edit" role="tabpanel">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0">Photos/Videos</h6>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => setShowUploadModal(true)}
                disabled={!vehicleId}
                title={!vehicleId ? 'Save vehicle to upload media' : 'Upload'}
              >
                Upload Photo/Video
              </button>
            </div>

            {!vehicleId ? (
              <div className="alert alert-info mb-0">
                Save the vehicle first to upload photos/videos.
              </div>
            ) : (
              <VehicleMediaGrid vehicleId={vehicleId} refreshKey={mediaRefreshKey} />
            )}

            <FileUploadModal
              show={showUploadModal}
              onClose={() => setShowUploadModal(false)}
              categories={["General"]}
              onConfirm={async ({ files, title }) => {
                if (!vehicleId) return;
                const formDataToSend = new FormData();
                formDataToSend.append('entityId', vehicleId);
                formDataToSend.append('entityType', 'vehicle');
                formDataToSend.append('fileCategory', 'General');
                formDataToSend.append('fileTitle', title || '');
                formDataToSend.append('UserId', getStorageValues('userId'));
                (files || []).forEach((file) => formDataToSend.append('files', file, file.name));
                appendApplicationId(formDataToSend);
                await axios.post(getApiBaseUrl() + "/file/upload", formDataToSend, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                });
                setMediaRefreshKey((x) => x + 1);
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default EditVehicle
